import Heatmap from "./Heatmap";
import HeatmapImages from "./HeatmapImages";
import ReportSettings from "./ReportSettings";
import SelectedFilterQuestion from "./SelectedFilterQuestion";
import Variable from "./Variable";

export enum ClicksForAnalysis {
  All = 0,
  First,
  Last,
}

export default interface HeatmapDto {
  projectId: string;
  environmentKey: string;
  reportSettings: ReportSettings;
  heatmap: Heatmap;
  selectedFilterQuestion: SelectedFilterQuestion;
  heatmapSourceImages: HeatmapImages;
  columns: number;
  rows: number;
  errors: string[];
  heatmapSubmitted: boolean;
  reportDownloadSubmitted: boolean;
  weightingVariable: Variable;
  isInProgress: boolean;
  minClustersCount: number;
  maxClustersCount: number;
  clustersCount: number;
  isClusteringEnabled: boolean;
  isExportEnabled: boolean;
  minRadius: number;
  maxRadius: number;
  radius: number;
  maxOpacity: number;
  minOpacity: number;
  clicksForAnalysis: ClicksForAnalysis;
}
